import React from 'react'

const Loading = () => (
  <div className="px2 py3 center">
    <div className="mt1 monospace h3 bold">Loading data...</div>
  </div>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading.js